// extracted by mini-css-extract-plugin
export var active = "_fy-7";
export var blink = "_fy-8";
export var dropDownSelector = "_fy-4";
export var dropDownWrapper = "_fy-3";
export var fakeCursor = "_fy-6";
export var fontSizeButton = "_fy-9";
export var formQuillEditor = "_fy-0";
export var pressed = "_fy-a";
export var qlBlank = "_fy-1";
export var textFormattingToolbar = "_fy-2";
export var textToolbarOption = "_fy-5";